import { styled } from "@mui/material/styles";
import { StyledCard } from "~/components/Common";

const styledName = "CategoryWrapper";

export const StyledCategoryList = styled(StyledCard, { name: styledName })({
  "&": {
    height: "100%",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    paddingBottom: "10px",
    width: "100%",
    maxWidth: "none",
  },
});

export const StyledBackBtn = styled("div", { name: styledName })({
  "&": {
    position: "absolute",
    top: "6px",
    left: "6px",
  },
});

export const StyledList = styled("div", { name: styledName })({
  "&": {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "calc(100% - 56px)",
    width: "100%",
  },
});
